import React,{useEffect,useMemo} from 'react';
import "./WifiDecision.css";
import Header from "../../../components/Header"
import wifiIcon from "../../../../assets/icons/Wifi.svg";
import keyIcon from "../../../../assets/icons/key.svg";
import copyIcon from "../../../../assets/icons/copy.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../../../customHooks/useAuth';
import Remarks from "../../../components/Remarks/Remarks"
import { toast } from 'react-toastify';
import axios from 'axios';
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';
 
export default function WifiDecision() {


    const navigate = useNavigate();
    const location = useLocation();
  
    const bookedRoomId = location.state?.bookedRoomId || "";
    const bookingId = location.state?.bookingId || "";
    const userId = location.state?.userId || "";
    const status = location.state?.status || "";
    const Data = location.state?.Data || {};
    const requestId = location.state?.requestId || "";
  
    const formattedStatus = useMemo(() => {
      return  status.replace('_', ' ');
    }, [status]);
  
    // Refresh Handle
    useAuth();
  
    // Check Id
    useEffect(()=>{
  
      const checkId = ()=>{
        if(userId==="" || bookingId==="" || bookedRoomId===""){
          navigate("/bookings");
        }
      }
        checkId();
    },[userId,bookingId,bookedRoomId,navigate]);


    // Function for Copying the Wifi Password
    const copyPassword = (password)=>{
        try{
            navigator.clipboard.writeText(password);
        }catch(error){
            console.log(error);
        }
    }

    // Close Request
    const closeRequest = async()=>{
        try{
            const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${requestId}/close`);
            // console.log("Request Cancelled : ",response.data);
            toast.success("Wifi Request Cancelled Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}});

        }catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        }
    }
    


  return (
    <div className='wifiDecision'>
        <Header title="Wifi Details" />
        <div className='wifiDecision-view'>
            
            <div className='wifi-view-status'>
                <h4>{formattedStatus}</h4>
            </div>

            <div className='wifi-data'>
                <h4>Number of Devices</h4>
                <div className='wifi-inp'>
                    <h5>{Data.number_of_devices}</h5>
                </div>
            </div>


            {Data.additional_comments && 
                <div className='wifi-data'>
                    <h4>Comments</h4>
                    <div className='wifi-comment'>
                        <h5>{Data.additional_comments}</h5>
                    </div>
                </div>
            }

            {
                Data.wifi_name_passwords.length > 0 && 
                Data.wifi_name_passwords.map((wifi, index) => (
                
                    <div className='wifi-details' key={index}>
                        <h4>Wifi {index + 1}</h4>
                        <div className='wifi-det'>
                            <img src={wifiIcon} alt="Wifi Icon" />
                            <h5>{wifi.wifi_name}</h5> {/* Assuming wifi.name contains the Wi-Fi name */}
                        </div>
                        <div className='wifi-key'>
                            <img src={keyIcon} alt="Key Icon" />
                            <h5>{wifi.wifi_password}</h5> {/* Assuming wifi.password contains the password */}
                            <img src={copyIcon} className="key-img" alt="Copy Icon" onClick={() => copyPassword(wifi.wifi_password)} />
                        </div>
                    </div>
                ))
            }


        </div>

        {/* Remarks */}
        {Data.remarks && 
            <Remarks para={Data.remarks} />
        }
        {!(status === "Declined_Hotel" || status === "Completed_Hotel" || status === "Closed_Hotel" || status === "Declined_Guest" || status === "Closed_Guest") && (
            <div className="wifiDec-btn">
                <button onClick={closeRequest}>Cancel Request</button>
            </div>
        )}
        


    </div>
  )
}
